export default "__VITE_ASSET__ec5e8562__"